module.exports = __webpack_public_path__ + "img/product_sk-ii_1.7915cd40.png";